import { useState } from "react"
import { Screen } from "./App"
import { checkUserExists } from "./api"
import { useT } from "@transifex/react"

export const EmailScreen = ({
  onComplete,
}: {
  onComplete: (nextScreen: Screen, email: string) => void
}) => {
  const t = useT()
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false)
  const [inputError, setInputError] = useState<string>()
  const [apiError, setApiError] = useState<string>()

  const submitEmail = async () => {
    setApiError(undefined)

    if (!email.includes("@")) {
      setInputError(t("Make sure you entered a correct email"))
      return
    }

    setLoading(true)
    try {
      const userExists = await checkUserExists(email)
      if (userExists) {
        onComplete(Screen.PasswordLogin, email)
      } else {
        onComplete(Screen.PasswordCreate, email)
      }
    } catch (error) {
      setApiError(t("Something went wrong, please try again."))
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {apiError !== undefined && <p className="App-api-error">{apiError}</p>}
      <p className="App-title">{t("Existing Motosumo user")}</p>
      <p className="App-description">
        {t("Enter the email address you used to create your Motosumo account.")}
      </p>
      <p className="App-title">{t("New Motosumo user")}</p>
      <p className="App-description">
        {t(
          "Enter the email address you wish to use for your Motosumo account.",
        )}
      </p>
      <form
        onSubmit={(event) => {
          event.preventDefault()
          submitEmail()
        }}
      >
        <input
          className="App-input email"
          type="email"
          value={email}
          placeholder={t("Email")}
          onChange={(event) => {
            setEmail(event.target.value)
            setInputError(undefined)
          }}
        />
        {inputError !== undefined && (
          <p className="App-input-error">{inputError}</p>
        )}
        {loading ? (
          <div className="loader" />
        ) : (
          <input
            className="App-button"
            type="submit"
            value={t("Continue")}
            disabled={loading}
          />
        )}
      </form>
    </>
  )
}
